import { Box } from "@mui/material";
import type { FC } from "react";
import { ContentPreview } from "../../modules/content-previews/content-preview";
import { UpdateImageryButton } from "../../modules/content-previews/update-imagery-button";
import type { MultiformatDimensions } from "../../modules/multiformat/store/types";

export const PreviewsSkeletons: FC<{
  dimensions: MultiformatDimensions;
  mfai_update_imagery: boolean;
}> = ({ dimensions, mfai_update_imagery }) => {
  return (
    <>
      {mfai_update_imagery && <UpdateImageryButton disabled={true} onClick={() => {}} />}
      <Box
        sx={[
          (theme) => ({
            display: "grid",
            gap: 2,
            [theme.breakpoints.down("xs")]: {
              gridTemplateColumns: "1fr",
            },
            [theme.breakpoints.up("sm")]: {
              gridTemplateColumns: "repeat(2, 1fr)",
            },
            [theme.breakpoints.up("lg")]: {
              gridTemplateColumns: "repeat(2, 1fr)",
            },
          }),
        ]}
      >
        {Array.from({ length: 4 }).map((_, i) => (
          <ContentPreview
            key={i}
            image={{ state: "loading" }}
            hidden={false}
            dimensions={dimensions}
          />
        ))}
      </Box>
    </>
  );
};
